import { cn as e } from "../utils/index.js";
import "react";
import { jsx as t } from "react/jsx-runtime";
import { cva as n } from "class-variance-authority";
//#region src/components/alert.tsx
var r = n("relative w-full rounded-lg border px-4 py-3 text-sm grid has-[>.icon]:grid-cols-[calc(var(--spacing)*4)_1fr] grid-cols-[0_1fr] has-[>.icon]:gap-x-3 gap-y-0.5 items-start [&>.icon]:size-[19px] [&>.icon]:translate-y-0.5 [&>.icon]:text-current", {
	variants: { variant: {
		default: "bg-card text-card-foreground",
		empty: "bg-(--neutral-50) text-(--neutral-500) text-[14px]/[24px] font-light",
		destructive: "text-destructive bg-card [&>svg]:text-current *:data-[slot=alert-description]:text-destructive/90",
		positive: "bg-(--seafoam-50) border-(--seafoam-500)"
	} },
	defaultVariants: { variant: "default" }
});
function i({ className: n, variant: i, ...a }) {
	return /* @__PURE__ */ t("div", {
		"data-slot": "alert",
		role: "alert",
		className: e(r({ variant: i }), n),
		...a
	});
}
function a({ className: n, ...r }) {
	return /* @__PURE__ */ t("div", {
		"data-slot": "alert-title",
		className: e("col-start-2 line-clamp-1 min-h-4 font-medium tracking-tight", n),
		...r
	});
}
function o({ className: n, ...r }) {
	return /* @__PURE__ */ t("div", {
		"data-slot": "alert-description",
		className: e("text-muted-foreground col-start-2 grid justify-items-start gap-1 text-sm [&_p]:leading-relaxed", n),
		...r
	});
}
function s({ className: n, ...r }) {
	return /* @__PURE__ */ t("div", {
		"data-slot": "alert-action",
		className: e("absolute right-2", n),
		style: { top: "calc(50% - 16px)" },
		...r
	});
}
//#endregion
export { i as Alert, s as AlertAction, o as AlertDescription, a as AlertTitle };
